export default __webpack_public_path__ + "125974335c0c9046c212339e74ea95e0.woff";